import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TuiError } from '@taiga-ui/core';

@Component({
  selector: 'ion-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule, TuiError],
})
export class ErrorMessageComponent {
  readonly errorMessageKey = input<string | undefined>();
}
